import { PublicMarketingIndexPage } from "@/pages/public/marketing/marketing-index";

export function ArticlesIndexPage() {
  return (
    <PublicMarketingIndexPage
      category="ARTICLES"
      title="Insights"
      description="Insights and practical guidance to help equipment dealers and buyers keep deals moving."
      pathBase="/articles"
    />
  );
}

